
import React from 'react';
import { useBackendStatus } from '../../hooks/useBackendStatus';

interface BackendRequiredProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    showDisabled?: boolean; // If true, render children but disabled (if button/input)
}

export default function BackendRequired({
    children,
    fallback = null,
    showDisabled = false
}: BackendRequiredProps) {
    const { isOnline } = useBackendStatus();

    if (isOnline) {
        return <>{children}</>;
    }

    if (showDisabled) {
        return (
            <div 
                title="Not available in offline mode"
                style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    display: 'contents'
                }}
            >
                <div style={{ pointerEvents: 'none' }}>
                    {children}
                </div>
            </div>
        );
    }

    return <>{fallback}</>;
}
